<template>
  <div class="userGuideShadow" v-if="show">
    <div class="userGuideView">
      <div class="btns">
        <img class="back" src="@/assets/goClass.png" @click="goClassPage()" />
        <span class="topButton" @click="goWebSite('/index/TaskList')"
          >作业中心</span
        >
        <span class="topButton" @click="goWebSite('https://oj.coding61.com/')"
          >橙子竞赛</span
        >
      </div>
      <img class="arrow" :src="images.arrow" />
      <p class="text">点击这里进入直播课程</p>
    </div>

    <div class="lockView">
      <img :src="images.lock" />
      <p class="content">
        社区处于锁定状态<br />如需解锁，请家长联系班主任老师~
      </p>
    </div>
  </div>
</template>

<script>
import { IMG_USER_GUIDE_ARROW, IMG_LOCK_SCHEDULE } from "@/assets";
import { SET_VALUE } from "@/utils";

import { types as LoginTypes } from "@/store/modules/login";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "UserSchedue",
  components: {},
  props: {},
  data() {
    return {
      images: {
        arrow: IMG_USER_GUIDE_ARROW,
        lock: IMG_LOCK_SCHEDULE
      },
      show: false
    };
  },
  watch: {},
  computed: {},
  methods: {
    ...mapActions({
      dependLoginStatus: LoginTypes.LOAD_LOGIN_STATUS,
      fetchHasAccess: LoginTypes.FETCH_HAS_ACCESS,
      fetchWhoamI: LoginTypes.FETCH_USERINFO
    }),

    showView() {
      this.show = true;
      document.body.style.setProperty("overflow", "hidden");
    },
    hideView() {
      this.show = false;
      document.body.style.removeProperty("overflow");
    },
    goClassPage() {
      location.href = "/index/CogaSelect";
    },
    // 去其他网页
    goWebSite(url) {
      if (url.includes("TaskList")) {
        // 登录状态判断
        this.dependLoginStatus().then(() => {
          window.open(url, "_blank");
        });
      } else {
        window.open(url, "_blank");
      }
    }
  },
  created() {},
  destroyed() {},
  mounted() {
    let callback = () => {
      this.fetchWhoamI().then(response => {
        console.log(response);
        if (response.is_class === true && response.is_staff === false) {
          this.goClassPage()
        } else {
          hasAccessCB()
        }
      });
    };
    let hasAccessCB = () => {
      this.fetchHasAccess()
        .then(response => {
          this.hideView();
        })
        .catch(err => {
          this.showView();
        });
    }
    this.dependLoginStatus("no_toast").then(hasAccessCB);
  }
};
</script>

<style lang="less" scoped>
.userGuideShadow {
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  position: fixed;
  overflow: auto;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 1100px;
  .userGuideView {
    width: 1000px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin: auto;
    position: absolute;
    top: 0;
    @media (min-width: 1100px) {
      left: calc((100% - 1000px) / 2);
    }
    @media (max-width: 1100px) {
      left: 50px;
    }
  }
  .btns {
    display: flex;
    margin-top: 10px;
    align-items: center;
    span {
      display: block;
      margin-left: 30px;
      font-size: 18px;
      color: #ffd200;
      cursor: pointer;
    }
  }
  .back {
    height: 44px;
  }
  .arrow {
    width: 60px;
    margin-left: 20px;
    margin-top: 10px;
  }
  .text {
    color: #ffae00;
    margin-left: -20px;
  }
  .lockView {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img {
      width: 200px;
    }
    .content {
      margin-top: 20px;
      color: #ffd200;
      font-size: 16px;
      text-align: center;
      line-height: 28px;
    }
  }
}
</style>
